import FieldNames from "../defaults/FieldNames.json";
import ColorConstants from "../defaults/ColorConstants";
import { Checkbox, Chip, Avatar, Tooltip, Grid, Paper } from '@mui/material';
import Box from "@mui/material/Box";
import { Fragment } from "react";
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { addCommas, chop, getCurrency, getNameOfOption } from "./FormatHelper";
import { getFeatureListCardTitle, getProjectListCardTitle, isFeaturePostFire } from "./FeatureHelper";
import ClearIcon from '@mui/icons-material/Clear';
import {formatDateForDisplay} from "./DateHelper";
import FieldInfo from '../components/details/FieldInfo.json';

const getListCardLeftSection = (id, isDraggable, selectedFeatures, selectFeature, styleHeight, featureAttr, listCardEntityType = "Action") => {
  if(isDraggable) {
    return (
      <Box style={{ borderRadius: '5px 0 0 5px', backgroundColor: ColorConstants.GrayBoxAlien }} display="flex" height={styleHeight}>
        <div style={{width: 30}}><p style={{ color: ColorConstants.WhiteAlien, width: 30, textAlign: 'center', fontWeight: 'bold', marginTop: 5}}>{id + 1}</p></div>
      </Box>
    )
  } else {
    const isFeatureActuals = (featureAttr[FieldNames.featureFields.class] === FieldNames.classTypes.actualActivity || featureAttr[FieldNames.featureFields.class] === FieldNames.classTypes.actualTreatment) ? true : false;
    const isFeatureTreatment = (featureAttr[FieldNames.featureFields.class] === FieldNames.classTypes.treatment || featureAttr[FieldNames.featureFields.class] === FieldNames.classTypes.actualTreatment) ? true : false;
    const {sideBarClass, sideBarColor, sideBarToolTip} = listCardEntityType === FieldNames.listCardEntityTypes.project ? getProjectListCardDisplayVariables(featureAttr) : getListCardDisplayVariables(isFeatureActuals, featureAttr)
    return (
      <Tooltip placement={"right"} arrow title={sideBarToolTip ? sideBarToolTip : '--'}>
        <Box style={{ borderRadius: '5px 0 0 5px', height: styleHeight, padding: 0, margin: 0, flexDirection: 'column', backgroundColor: sideBarColor }} className={sideBarClass} display="flex">
          <Checkbox
            style={{
              color: ColorConstants.WhiteAlien,
              padding: '2px 0px'
            }}
            checked={selectedFeatures.map(ea => ea[FieldNames.featureFields.id]).includes(id)}
            className="featureCheckboxSelection"
            id={`checkbox-${id}`}
            onChange={(e) => {
              selectFeature(e, featureAttr, isFeatureTreatment, isFeatureActuals, FieldNames.featureFields)
            }}
            sx={{ '& .MuiSvgIcon-root': { fontSize: 24 } }}
          />
        </Box>
      </Tooltip>
    )
  }
}

export const getListCard = (id, featureAttr, isDraggable, cardStyles, conditionalItems = null, listCardEntityType = FieldNames.listCardEntityTypes.action) => {
  const isFeatureActuals = (featureAttr[FieldNames.featureFields.class] === FieldNames.classTypes.actualActivity || featureAttr[FieldNames.featureFields.class] === FieldNames.classTypes.actualTreatment) ? true : false;
  const isFeatureTreatment = (featureAttr[FieldNames.featureFields.class] === FieldNames.classTypes.treatment || featureAttr[FieldNames.featureFields.class] === FieldNames.classTypes.actualTreatment) ? true : false;
  const isFeatureProject = listCardEntityType === FieldNames.listCardEntityTypes.project;
  const isPostfire = isFeaturePostFire(featureAttr, isFeatureProject);
  const { styleHeight, styleWidth, cardSizes, arrowListCard, backgroundClassListCard, classesListCard, backgroundClass } = cardStyles;
  const { objectId, onClicked, selectedFeatures, selectFeature, createActual, reportActual, navigateToEstimated, isGroupingsLoading, onGroupEdit } = conditionalItems;
  return(
    <Paper elevation={6} style={{ display: 'flex', borderRadius: 5, height: styleHeight}} className={arrowListCard}>
      <Box p={1} style={{ margin: 0, backgroundColor: ColorConstants.WhiteAlien, borderRadius: 5, width: styleWidth}}>
        <Grid container spacing={1} style={{ width: '100%', padding: 0, margin: 0, justifyContent: 'space-between'}} className={backgroundClass}>
          <Grid item className={classesListCard} size={1} style={{ padding: 0, margin: 0, maxWidth: '25px'}}>
            {getListCardLeftSection(id, isDraggable, selectedFeatures, selectFeature, styleHeight, featureAttr, listCardEntityType)}
          </Grid>
          <Grid item size={10} style={{ paddingLeft: 5}} className={backgroundClassListCard} onClick={(e) => {
              if(isDraggable){
                e.preventDefault();
              } else {
                if(isFeatureProject)
                {
                  onClicked(e, objectId, isPostfire);
                }
                else
                {
                  onClicked(e, objectId, isFeatureTreatment, isFeatureActuals, isPostfire);
                }
              }
            }}>
            {
              listCardEntityType === FieldNames.listCardEntityTypes.project
              ? // Check if Projects
              getProjectListCardMainSection(cardSizes, featureAttr)
              : // Default is Actions
              getListCardMainSection(cardSizes, featureAttr, createActual, reportActual, navigateToEstimated, isGroupingsLoading,
              onGroupEdit, isDraggable)
            }
          </Grid>
          <Grid item className={backgroundClass} size={1} style={{ padding: 0, margin: 0, maxWidth: '25px'}} onClick={(e) => {
            if(isDraggable){
              e.preventDefault();
              // Is this an issue?
              onClicked(e, featureAttr)
            } else {
              onClicked(e, objectId, isFeatureTreatment, isFeatureActuals, isPostfire);
            }
          }}>
            {getListCardRightSection(styleHeight, isDraggable)}
          </Grid>
        </Grid>
      </Box>
    </Paper>
  )
}

const getListCardMainSection = (cardSizes, featureAttr, createActual,
  reportActual, navigateToEstimated, isGroupingsLoading, onGroupEdit, isDraggable) => {
  const tempName = getFeatureListCardTitle(featureAttr);
  const featureName = tempName ? tempName : "Estimated Treatment";
  const acres = getAcresWithModifications(featureAttr[FieldNames.featureFields.calculatedArea]);
  const subTotals = featureAttr[FieldNames.featureFields.estimatedTotalCost] ? getCurrencyWithModifications(featureAttr[FieldNames.featureFields.estimatedTotalCost]) : "––";
  const isFeatureActuals = (featureAttr[FieldNames.featureFields.class] === FieldNames.classTypes.actualActivity || featureAttr[FieldNames.featureFields.class] === FieldNames.classTypes.actualTreatment) ? true : false;
  const isFeatureTreatment = (featureAttr[FieldNames.featureFields.class] === FieldNames.classTypes.treatment || featureAttr[FieldNames.featureFields.class] === FieldNames.classTypes.actualTreatment) ? true : false;
  const category = featureAttr[FieldNames.featureFields.category] ? chop(getNameOfOption(featureAttr[FieldNames.featureFields.category], FieldNames.featureFields.category, FieldNames.transitionBetweenValues), 12) : "––";
  const type = featureAttr[FieldNames.featureFields.type] ? chop(getNameOfOption(featureAttr[FieldNames.featureFields.type], FieldNames.featureFields.type, FieldNames.transitionBetweenValues), 15) : "––";
  const status = featureAttr[FieldNames.featureFields.status] ? chop(getNameOfOption(featureAttr[FieldNames.featureFields.status], FieldNames.featureFields.status, FieldNames.transitionBetweenValues), 15) : "––";
  const initFY = featureAttr[FieldNames.featureFields.initiationFiscalYear] ? chop(featureAttr[FieldNames.featureFields.initiationFiscalYear], 4) : "––";
  const compFY = featureAttr[FieldNames.featureFields.completionFiscalYear] ? chop(featureAttr[FieldNames.featureFields.completionFiscalYear], 4) : "––";
  const name = featureAttr[FieldNames.featureFields.name] ? chop(featureAttr[FieldNames.featureFields.name], cardSizes === FieldNames.listCardTypes.condensed ? 40 : 76) : "––";
  const localID = featureAttr[FieldNames.featureFields.localID] ? chop(featureAttr[FieldNames.featureFields.localID], cardSizes === FieldNames.listCardTypes.condensed ? 20 : 30) : "––";
  const isBIL = featureAttr[FieldNames.featureFields.isBIL] ? featureAttr[FieldNames.featureFields.isBIL] : "––";
  const locationState = featureAttr[FieldNames.featureFields.state] ? chop(featureAttr[FieldNames.featureFields.state], 12) : "––";
  const fundUnit = featureAttr[FieldNames.featureFields.fundingUnit] ? chop(featureAttr[FieldNames.featureFields.fundingUnit], 12) : "––";
  const isApprovedFullyFunded = isFullyApprovedAndFunded(featureAttr, FieldNames.featureFields, isFeatureTreatment);
  const costName = isFeatureActuals ? "Subtotal Costs" : "Estimated Costs";
  const areaUnit = featureAttr[FieldNames.featureFields.areaUnit] ? featureAttr[FieldNames.featureFields.areaUnit] : 'Area';

  return (
    <Fragment>
    {cardSizes === FieldNames.listCardTypes.detailed &&
      <Fragment>
        <Grid container direction="row" item size={12}>
          <Grid item size={9} className='incident-list-sort-panel-vir'>{fieldSection(featureName, name, featureAttr[FieldNames.featureFields.name], cardSizes)}</Grid>
          <Grid item size={3} className='incident-list-sort-panel-vir'>{fieldSection("Local ID", localID, featureAttr[FieldNames.featureFields.localID], cardSizes)}</Grid>
        </Grid>
        <Grid container direction="row" item size={12}>
        {(compFY && compFY !=="––") &&
            <Grid item size={3} className='incident-list-sort-panel-vir'>{fieldSection("FY", compFY, featureAttr[FieldNames.featureFields.completionFiscalYear], cardSizes)}</Grid>
          }
          {(!compFY || compFY === "––") &&
            <Grid item size={3} className='incident-list-sort-panel-vir'>{fieldSection("FY", initFY, featureAttr[FieldNames.featureFields.initiationFiscalYear], cardSizes)}</Grid>
          }
          <Grid item size={3} className='incident-list-sort-panel-vir'>{fieldSection(areaUnit, acres, featureAttr[FieldNames.featureFields.calculatedArea], cardSizes)}</Grid>
          <Grid item size={3} className='incident-list-sort-panel-vir'>{fieldSection(costName, subTotals, featureAttr[FieldNames.featureFields.estimatedTotalCost], cardSizes)}</Grid>
          <Grid item size={3} className='incident-list-sort-panel-vir'>{fieldSection("Status", status, featureAttr[FieldNames.featureFields.status], cardSizes)}</Grid>

        </Grid>
        <Grid container direction="row" item size={12}>
          <Grid item size={3} className='incident-list-sort-panel-vir'>{fieldSection("Category", category, featureAttr[FieldNames.featureFields.category], cardSizes)}</Grid>

          <Grid item size={3} className='incident-list-sort-panel-vir'>{fieldSection("Type", type, featureAttr[FieldNames.featureFields.type], cardSizes)}</Grid>
          <Grid item size={3} className='incident-list-sort-panel-vir'>{fieldSection("IsBIL", isBIL, featureAttr[FieldNames.featureFields.isBIL], cardSizes)}</Grid>
          <Grid item size={3} className='incident-list-sort-panel-vir'>{fieldSection("State", locationState, featureAttr[FieldNames.featureFields.state], cardSizes)}</Grid>
        </Grid>
        <Grid container direction="row" item size={12}>
          <Grid item size={3} className='incident-list-sort-panel-vir'>{fieldSection("Funding Unit", fundUnit, featureAttr[FieldNames.featureFields.fundingUnit], cardSizes)}</Grid>
          {/*this breaks the card layout.  add back if requested and fix the layout */}
          {/*<Grid item size={3} className='incident-list-sort-panel-vir'>{fieldSection("Is Progressive Reporting", isProgressiveReporting, featureAttr[FieldNames.featureFields.isProgressiveReporting], cardSizes)}</Grid>*/}
          {(!isFeatureActuals && isFeatureTreatment && !isDraggable) &&
            <Fragment>
              {(featureAttr[FieldNames.featureFields.isProgressiveReporting] !== FieldNames.yesNo.yes) ? <Grid item size={4} className='incident-list-sort-panel-vir'>
                 <div className="list-item-incident-name-vir">
                  {(!isFeatureActuals && (featureAttr[FieldNames.featureFields.hasActual] === FieldNames.yesNo.no || !featureAttr[FieldNames.featureFields.hasActual]) && featureAttr[FieldNames.featureFields.category] !== FieldNames.categoriesForChecking.programManagement) ?
                      <Chip
                          disabled={!isApprovedFullyFunded || (featureAttr && featureAttr[FieldNames.featureFields.unApprovalDate])}
                          className="required-field-status-chip"
                          onClick={() => createActual(isFeatureTreatment, featureAttr)}
                          avatar={<Avatar style={{
                            fontSize: "12px",
                            width: "22px",
                            height: "22px",
                            backgroundColor: ColorConstants.AvatarColor,
                            color: ColorConstants.WhiteAlien
                          }}><AddIcon/></Avatar>}
                          label={<span style={{fontSize: "12px", lineHeight: "21px"}}>Create Actual</span>}/> : ''}
                  {(!isFeatureActuals && featureAttr[FieldNames.featureFields.hasActual] === FieldNames.yesNo.yes && featureAttr[FieldNames.featureFields.category] !== FieldNames.categoriesForChecking.programManagement) ?
                      <Chip
                          className="required-field-status-chip"
                          onClick={() => reportActual(isFeatureTreatment, featureAttr)}
                          avatar={<Avatar style={{
                            fontSize: "12px",
                            width: "22px",
                            height: "22px",
                            backgroundColor: ColorConstants.AvatarColor,
                            color: ColorConstants.WhiteAlien
                          }}><SearchIcon style={{width: '18px', height: '18px'}}/></Avatar>}
                          label={<span style={{fontSize: "12px", lineHeight: "21px"}}>Report on Actual</span>}/> : ''}
                </div>
              </Grid> : ''}
              <Grid item size={4} className='incident-list-sort-panel-vir'>
                <div className="list-item-incident-name-vir">
                  {(featureAttr && featureAttr[FieldNames.featureFields.hasGroup] === FieldNames.yesNo.yes && featureAttr[FieldNames.featureFields.groupCount] > 0) ? <Chip
                  className="required-field-status-chip"
                  disabled={isGroupingsLoading}
                  onClick={() => onGroupEdit(featureAttr, isFeatureTreatment, isFeatureActuals)}
                  avatar={<Avatar style={{fontSize: "12px", width: "22px", height: "22px", backgroundColor: ColorConstants.AvatarColor, color: ColorConstants.WhiteAlien }}>{featureAttr[FieldNames.featureFields.groupCount]}</Avatar>}
                  label={<span style={{fontSize: "12px", lineHeight: "21px"}}>{featureAttr[FieldNames.featureFields.groupCount] === 1 ? "Associated Group" : "Associated Groups"}</span>}
                /> : ''}
                </div>
              </Grid>
            </Fragment>
          }
          {(!isFeatureActuals && !isFeatureTreatment && !isDraggable) &&
            <Grid item size={9} className='incident-list-sort-panel-vir'>
              {(!isFeatureActuals && (featureAttr[FieldNames.featureFields.hasActual] === FieldNames.yesNo.no || !featureAttr[FieldNames.featureFields.hasActual]) && featureAttr[FieldNames.featureFields.category] !== FieldNames.categoriesForChecking.programManagement) ? <Chip
                disabled={!isApprovedFullyFunded || (featureAttr && featureAttr[FieldNames.featureFields.unApprovalDate])}
                className="required-field-status-chip"
                onClick={() => createActual(isFeatureTreatment, featureAttr)}
                avatar={<Avatar style={{fontSize: "12px", width: "22px", height: "22px", backgroundColor: ColorConstants.AvatarColor, color: ColorConstants.WhiteAlien }}><AddIcon /></Avatar>}
                label={<span style={{fontSize: "12px", lineHeight: "21px"}}>Create Actual</span>}
              /> : ''}
              {(!isFeatureActuals && featureAttr[FieldNames.featureFields.hasActual] === FieldNames.yesNo.yes && featureAttr[FieldNames.featureFields.category] !== FieldNames.categoriesForChecking.programManagement) ? <Chip
                className="required-field-status-chip"
                onClick={() => reportActual(isFeatureTreatment, featureAttr)}
                avatar={<Avatar style={{fontSize: "12px", width: "22px", height: "22px", backgroundColor: ColorConstants.AvatarColor, color: ColorConstants.WhiteAlien }}><SearchIcon style={{ width: '18px', height: '18px'}} /></Avatar>}
                label={<span style={{fontSize: "12px", lineHeight: "21px"}}>Report on Actual</span>}
              /> : ''}
              {(featureAttr && featureAttr[FieldNames.featureFields.hasGroup] === FieldNames.yesNo.yes && featureAttr[FieldNames.featureFields.groupCount] > 0) ? <Chip
                className="required-field-status-chip"
                disabled={isGroupingsLoading}
                onClick={() => onGroupEdit(featureAttr, isFeatureTreatment, isFeatureActuals)}
                avatar={<Avatar style={{fontSize: "12px", width: "22px", height: "22px", backgroundColor: ColorConstants.AvatarColor, color: ColorConstants.WhiteAlien }}>{featureAttr[FieldNames.featureFields.groupCount]}</Avatar>}
                label={<span style={{fontSize: "12px", lineHeight: "21px"}}>{featureAttr[FieldNames.featureFields.groupCount] === 1 ? "Associated Group" : "Associated Groups"}</span>}
              /> : ''}
            </Grid>
          }
          {(isFeatureActuals && !isDraggable) &&
          <Fragment>
            <Grid item size={4} className='incident-list-sort-panel-vir'>
              <div className="list-item-incident-name-vir">
                {(featureAttr && featureAttr[FieldNames.featureFields.hasGroup] === FieldNames.yesNo.yes && featureAttr[FieldNames.featureFields.groupCount] > 0) ? <Chip
                className="required-field-status-chip"
                disabled={isGroupingsLoading}
                onClick={() => onGroupEdit(featureAttr, isFeatureTreatment, isFeatureActuals)}
                avatar={<Avatar style={{fontSize: "12px", width: "22px", height: "22px", backgroundColor: ColorConstants.AvatarColor, color: ColorConstants.WhiteAlien }}>{featureAttr[FieldNames.featureFields.groupCount]}</Avatar>}
                label={<span style={{fontSize: "12px", lineHeight: "21px"}}>{featureAttr[FieldNames.featureFields.groupCount] === 1 ? "Associated Group" : "Associated Groups"}</span>}
              /> : ''}
              </div>
            </Grid>
            <Grid item size={4} className='incident-list-sort-panel-vir'>
                <Chip
                    disabled={featureAttr[FieldNames.featureFields.joinID] === null ? true : false}
                    className="required-field-status-chip"
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      navigateToEstimated(isFeatureTreatment, featureAttr);
                    }}
                    avatar={<Avatar style={{fontSize: "12px", width: "22px", height: "22px", backgroundColor: ColorConstants.AvatarColor, color: ColorConstants.WhiteAlien }}><SearchIcon style={{ width: '18px', height: '18px'}} /></Avatar>}
                    label={<span style={{fontSize: "12px", lineHeight: "21px"}}>{featureAttr[FieldNames.featureFields.groupCount] === 1 ? "Open Estimated" : "Open Estimated"}</span>}
                  />
              </Grid>
            </Fragment>
          }
        </Grid>
      </Fragment>
    }
    {cardSizes === FieldNames.listCardTypes.condensed &&
      <Fragment>
        <Grid container direction="row" item size={12}>
          <Grid item size={5} className='incident-list-sort-panel-vir'>{fieldSection(featureName, name, featureAttr[FieldNames.featureFields.name], cardSizes)}</Grid>
          <Grid item size={2} className='incident-list-sort-panel-vir'>{fieldSection("Local ID", localID, featureAttr[FieldNames.featureFields.localID], cardSizes)}</Grid>
          {(compFY && compFY !=="––") &&
            <Grid item size={1} className='incident-list-sort-panel-vir'>{fieldSection("FY", compFY, featureAttr[FieldNames.featureFields.completionFiscalYear], cardSizes)}</Grid>
          }
          {(!compFY || compFY === "––") &&
            <Grid item size={1} className='incident-list-sort-panel-vir'>{fieldSection("FY", initFY, featureAttr[FieldNames.featureFields.initiationFiscalYear], cardSizes)}</Grid>
          }
          <Grid item size={2} className='incident-list-sort-panel-vir'>{fieldSection(areaUnit, acres, featureAttr[FieldNames.featureFields.calculatedArea], cardSizes)}</Grid>
          <Grid item size={2} className='incident-list-sort-panel-vir'>{fieldSection("Estimated Costs", subTotals, featureAttr[FieldNames.featureFields.estimatedTotalCost], cardSizes)}</Grid>
        </Grid>
      </Fragment>
    }
    </Fragment>
  )
}

const getProjectListCardMainSection = (cardSizes, featureAttr) => {
  const tempName = getProjectListCardTitle(featureAttr);
  const featureName = tempName ? tempName : "Estimated Treatment";
  const name = featureAttr[FieldNames.projectFields.name] ? chop(featureAttr[FieldNames.projectFields.name], cardSizes === FieldNames.listCardTypes.condensed ? 40 : 76) : "––";
  const wildfireAcres = getAcresWithModifications(featureAttr[FieldNames.projectFields.wildfireAcres]);
  const fireCode = featureAttr[FieldNames.projectFields.fireCode] ? chop(featureAttr[FieldNames.projectFields.fireCode], cardSizes === FieldNames.listCardTypes.condensed ? 40 : 76) : "––";
  const irwinID = featureAttr[FieldNames.projectFields.irwinID] ? chop(featureAttr[FieldNames.projectFields.irwinID], cardSizes === FieldNames.listCardTypes.condensed ? 40 : 76) : "––";
  const fireDiscoveryDate = featureAttr[FieldNames.projectFields.fireDiscoveryDate] ? formatDateForDisplay(featureAttr[FieldNames.projectFields.fireDiscoveryDate]) : "--";
  const containmentDate = featureAttr[FieldNames.projectFields.containmentDate] ? formatDateForDisplay(featureAttr[FieldNames.projectFields.containmentDate]) : "--";
  const ignitionFiscalYear = featureAttr[FieldNames.projectFields.ignitionFiscalYear] ? chop(featureAttr[FieldNames.projectFields.ignitionFiscalYear], 4) : "––";

  return (
    <Fragment>
    {cardSizes === FieldNames.listCardTypes.detailed &&
      <Fragment>
        <Grid container direction="row" item size={12}>
          <Grid item size={12} className='incident-list-sort-panel-vir'>{fieldSection(featureName, name, featureAttr[FieldNames.featureFields.name], cardSizes)}</Grid>
        </Grid>
        <Grid container direction="row" item size={12}>
          <Grid item size={3} className='incident-list-sort-panel-vir'>{fieldSection("Wildfire Acres", wildfireAcres, featureAttr[FieldNames.projectFields.wildfireAcres], cardSizes)}</Grid>
          <Grid item size={3} className='incident-list-sort-panel-vir'>{fieldSection("Fire Code", fireCode, featureAttr[FieldNames.projectFields.fireCode], cardSizes)}</Grid>
          <Grid item size={6} className='incident-list-sort-panel-vir'>{fieldSection("Irwin ID", irwinID, featureAttr[FieldNames.projectFields.irwinID], cardSizes)}</Grid>
        </Grid>
        <Grid container direction="row" item size={12}>
          <Grid item size={3} className='incident-list-sort-panel-vir'>{fieldSection("Fire Discovery Date", fireDiscoveryDate, formatDateForDisplay(featureAttr[FieldNames.projectFields.fireDiscoveryDate]), cardSizes)}</Grid>
          <Grid item size={3} className='incident-list-sort-panel-vir'>{fieldSection("Containment Date", containmentDate, formatDateForDisplay(featureAttr[FieldNames.projectFields.containmentDate]), cardSizes)}</Grid>
          <Grid item size={1} className='incident-list-sort-panel-vir'>{fieldSection("Fiscal Year", ignitionFiscalYear, featureAttr[FieldNames.projectFields.ignitionFiscalYear], cardSizes)}</Grid>
        </Grid>
        <Grid container direction="row" item size={12}>
          {/* <Grid item size={3} className='incident-list-sort-panel-vir'>{fieldSection("Funding Unit", fundUnit, featureAttr[FieldNames.featureFields.fundingUnit], cardSizes)}</Grid> */}

        </Grid>
      </Fragment>
    }
    {cardSizes === FieldNames.listCardTypes.condensed &&
      <Fragment>
        <Grid container direction="row" item size={12}>
          <Grid item size={7} className='incident-list-sort-panel-vir'>{fieldSection(featureName, name, featureAttr[FieldNames.projectFields.name], cardSizes)}</Grid>
          <Grid item size={2} className='incident-list-sort-panel-vir'>{fieldSection("Wildfire Acres", wildfireAcres, featureAttr[FieldNames.projectFields.wildfireAcres], cardSizes)}</Grid>
          <Grid item size={1} className='incident-list-sort-panel-vir'>{fieldSection("Fiscal Year", ignitionFiscalYear, featureAttr[FieldNames.projectFields.ignitionFiscalYear], cardSizes)}</Grid>
        </Grid>
      </Fragment>
    }
    </Fragment>
  )
}

const fieldSection = (labelName, value, fullLengthValue, cardSizes) => {
  let modifiedFullLengthValue = fullLengthValue;
  let modifiedValue = value;

  if(fullLengthValue && value && (['Wildfire Acres', 'Area', ...FieldInfo.AreaUnit.domain.codedValues.map(v => v.value)].includes(labelName))){

    modifiedFullLengthValue = getAcresWithModifications(fullLengthValue);
    let modValue = getAcresWithModifications(value);
    if(cardSizes === FieldNames.listCardTypes.condensed && modValue && modValue.length >= 8){
      modifiedValue = "XXX,XXX";
    } else if(cardSizes === FieldNames.listCardTypes.detailed && modValue && modValue.length > 18) {
      modifiedValue = "X,XXX,XXX,XXX";
    } else {
      modifiedValue = modValue;
    }
  }

  if(fullLengthValue && value && (labelName === "Estimated Costs" || labelName === "Subtotal Costs")){
    modifiedFullLengthValue = getCurrencyWithModifications(fullLengthValue);
    let modValue = getCurrencyWithModifications(value);
    if(cardSizes === FieldNames.listCardTypes.condensed && modValue && modValue.length > 9){
      modifiedValue = "$X,XXX,XXX";
    } else if(cardSizes === FieldNames.listCardTypes.detailed && modValue && modValue.length > 14) {
      modifiedValue = "$X,XXX,XXX,XXX";
    } else {
      modifiedValue = modValue;
    }
  }

  if(modifiedFullLengthValue && modifiedValue){
    if(modifiedFullLengthValue === modifiedValue){
      return (
        <Fragment>
          <label>{labelName}</label>
          <p className="list-item-incident-name-vir" style={{ whiteSpace: 'break-spaces', wordBreak: 'break-all'}}>{modifiedFullLengthValue ? modifiedFullLengthValue : "--"}</p>
        </Fragment>
      )
    } else {
      return (
        <Fragment>
          <label>{labelName}</label>
          <Tooltip title={modifiedFullLengthValue ? modifiedFullLengthValue : '--'}>
            <p className="list-item-incident-name-vir" style={{ whiteSpace: 'break-spaces', wordBreak: 'break-all'}}>{modifiedValue ? modifiedValue : "--"}</p>
          </Tooltip>
        </Fragment>
      )
    }
  } else {
    return(
      <Fragment>
          <label>{labelName}</label>
          <p className="list-item-incident-name-vir" style={{ whiteSpace: 'break-spaces', wordBreak: 'break-all'}}>--</p>
        </Fragment>
    )
  }

}

const getListCardRightSection = (styleHeight, isDraggable) => {
  if(isDraggable){
    return (
      <Box style={{ borderRadius: '0 5px 5px 0px', backgroundColor: 'red', width: '30px' }} display="flex" height="1">
        <ClearIcon fontSize='small' style={{
          color: "white",
          height: "100%",
          margin: "auto"
        }} />
      </Box>
    )
  } else {
    return (
      <Box style={{ borderRadius: '5px 0 0 5px', width: '100%' }} display="flex" height="1">
        <Grid item style={{ padding: 0, margin: 0, width: '100%'}} onClick={(e) => {
          return false;
          }}>
          <Box style={{ borderRadius: '0 5px 5px 0', height: styleHeight, width: '100%', padding: 0, margin: 0 }} display="flex" >
            <ArrowForwardIosIcon fontSize='small' style={{
              color: "gray",
              height: styleHeight,
              margin: "0 0px 0 0"
            }} />
          </Box>
        </Grid>
      </Box>
    )
  }
}

const getListCardDisplayVariables = (isFeatureActuals, featureAttr) => {
  let sideBarClass = null;
  let sideBarColor = null;
  let sideBarToolTip = ``;

  if(!isFeatureActuals){
    //orange-color, yellow-color, gray-color, dark-purple-color, mid-dark-purple-color, mid-light-purple-color, light-purple-color, dark-blue-color , mid-blue-color, light-blue-color, cancelled-color
    //For Estimated we have In Draft, Ready for Approvals, Approved (Local), Approved (Regional), Approved (Agency), Approved (Department), and Cancelled
    if(featureAttr[FieldNames.featureFields.status] === FieldNames.statuses.cancelled){
      sideBarClass = `cancelled-color`;
      sideBarColor = ColorConstants.WhiteAlien;
      sideBarToolTip = `${FieldNames.statuses.cancelled}`;
    } else if(featureAttr[FieldNames.featureFields.status] === FieldNames.statuses.approvedAgency) {
      sideBarColor = ColorConstants.StatusColors.AgencyApproved;
      sideBarToolTip = FieldNames.statuses.approvedAgency;
    } else if(featureAttr[FieldNames.featureFields.status] === FieldNames.statuses.approvedDepartment) {
      sideBarColor = ColorConstants.StatusColors.DepartmentApproved;
      sideBarToolTip = FieldNames.statuses.approvedDepartment;
    } else if(featureAttr[FieldNames.featureFields.status] === FieldNames.statuses.approvedLocal) {
      sideBarColor = ColorConstants.StatusColors.LocalApproved;
      sideBarToolTip = FieldNames.statuses.approvedLocal;
    } else if(featureAttr[FieldNames.featureFields.status] === FieldNames.statuses.approvedRegional) {
      sideBarColor = ColorConstants.StatusColors.RegionApproved;
      sideBarToolTip = FieldNames.statuses.approvedRegional;
    } else if(featureAttr[FieldNames.featureFields.status] === FieldNames.statuses.draft) {
      sideBarColor = ColorConstants.StatusColors.Draft;
      sideBarToolTip = FieldNames.statuses.draft;
    } else if(featureAttr[FieldNames.featureFields.status] === FieldNames.statuses.readyForApproval) {
      sideBarColor = ColorConstants.StatusColors.ReadyForApproval;
      sideBarToolTip = FieldNames.statuses.readyForApproval;
    } else if(featureAttr[FieldNames.featureFields.status] === FieldNames.statuses.completed) {
      sideBarColor = ColorConstants.StatusColors.Completed;
      sideBarToolTip = `${FieldNames.statuses.completed}`;
    } else if(featureAttr[FieldNames.featureFields.status] === FieldNames.statuses.notStarted) {
      sideBarColor = ColorConstants.StatusColors.NotStarted;
      sideBarToolTip = `${FieldNames.statuses.notStarted}`;
    } else if(featureAttr[FieldNames.featureFields.status] === FieldNames.statuses.started) {
      sideBarColor = ColorConstants.StatusColors.Started;
      sideBarToolTip = `${FieldNames.statuses.started}`;
    } else if(featureAttr[FieldNames.featureFields.status] === FieldNames.statuses.unApprovalRequested){
      sideBarClass = `un-approval-requested-color`;
      sideBarToolTip = FieldNames.statuses.unApprovalRequested;
    } else {
      if(featureAttr[FieldNames.featureFields.unApprovalDate]){
        sideBarClass = `un-approval-requested-color`;
        sideBarToolTip = FieldNames.statuses.unApprovalRequested;
      } else {
        if(!featureAttr[FieldNames.featureFields.localApprovalDate] && !featureAttr[FieldNames.featureFields.regionalApprovalDate] && !featureAttr[FieldNames.featureFields.agencyApprovalDate] && !featureAttr[FieldNames.featureFields.departmentApprovalDate]) {
          sideBarColor = ColorConstants.StatusColors.ReadyForApproval;
          sideBarToolTip = FieldNames.statuses.readyForApproval;
        } else if(featureAttr[FieldNames.featureFields.localApprovalDate] && !featureAttr[FieldNames.featureFields.regionalApprovalDate] && !featureAttr[FieldNames.featureFields.agencyApprovalDate] && !featureAttr[FieldNames.featureFields.departmentApprovalDate]){
            //If has a local Approval Date
            sideBarColor = ColorConstants.StatusColors.LocalApproved;
            sideBarToolTip = FieldNames.statuses.approvedLocal;
        } else if(featureAttr[FieldNames.featureFields.regionalApprovalDate] && !featureAttr[FieldNames.featureFields.agencyApprovalDate] && !featureAttr[FieldNames.featureFields.departmentApprovalDate]) {
          sideBarColor = ColorConstants.StatusColors.RegionApproved;
          sideBarToolTip = FieldNames.statuses.approvedRegional;
        } else if(featureAttr[FieldNames.featureFields.agencyApprovalDate] && !featureAttr[FieldNames.featureFields.departmentApprovalDate]) {
          sideBarColor = ColorConstants.StatusColors.AgencyApproved;
          sideBarToolTip = FieldNames.statuses.approvedAgency;
        } else if(featureAttr[FieldNames.featureFields.departmentApprovalDate]) {
          sideBarColor = ColorConstants.StatusColors.DepartmentApproved;
          sideBarToolTip = FieldNames.statuses.approvedDepartment;
        } else {
          sideBarColor = ColorConstants.GrayBoxAlien;
          sideBarToolTip = ``;
        }
      }
    }
  } else {
    //For Actuals we have Not Started, Started, and Completed -> All based on status
    if(featureAttr[FieldNames.featureFields.status] === FieldNames.statuses.notStarted){
      sideBarColor = ColorConstants.StatusColors.NotStarted;
      sideBarToolTip = `${FieldNames.statuses.notStarted}`;
    } else if(featureAttr[FieldNames.featureFields.status] === FieldNames.statuses.started){
      sideBarColor = ColorConstants.StatusColors.Started;
      sideBarToolTip = `${FieldNames.statuses.started}`;
    } else if(featureAttr[FieldNames.featureFields.status] === FieldNames.statuses.completed){
      sideBarColor = ColorConstants.StatusColors.Completed;
      sideBarToolTip = `${FieldNames.statuses.completed}`;
    } else if(featureAttr[FieldNames.featureFields.status] === FieldNames.statuses.cancelled){
      sideBarClass = `cancelled-color`;
      sideBarColor = ColorConstants.WhiteAlien;
      sideBarToolTip = `${FieldNames.statuses.cancelled}`;
    }
  }

  // Card Background
  if(featureAttr[FieldNames.featureFields.isCarryover] === FieldNames.yesNo.yes)
  {
    sideBarToolTip = `[Carryover] ${sideBarToolTip}`;
  }

  return {sideBarClass, sideBarColor, sideBarToolTip}
}

const getProjectListCardDisplayVariables = (featureAttr) => {
  let sideBarClass = null;
  let sideBarColor = null;
  let sideBarToolTip = ``;

  sideBarColor = ColorConstants.ProjectColors.Default;
  sideBarToolTip = "Project";

  return {sideBarClass, sideBarColor, sideBarToolTip}
}

const getAcresWithModifications = (acres) => {
  let newAcres = acres;
  if(acres){
    newAcres = acres.toString().replaceAll(",", "");
    newAcres = Math.ceil(newAcres);
    newAcres = addCommas(newAcres);
  }
  return newAcres;
}

const getCurrencyWithModifications = (amount) => {
  let newAmount = amount;
  if(amount){
    newAmount = amount.toString().replaceAll(",", "").replaceAll("$", "");
    newAmount = getCurrency(addCommas(newAmount));
  }
  return newAmount;
}

export const isFullyApprovedAndFunded = (featureAttr, featureFields, isFeatureTreatment) => {
  const agencyValue = featureAttr[featureFields.agencyApprovalDate];
  const regionalValue = featureAttr[featureFields.regionalApprovalDate];
  const departmentValue = featureAttr[featureFields.departmentApprovalDate];
  const localValue = featureAttr[featureFields.localApprovalDate];
  const isFunded = featureAttr[featureFields.isFunded] === FieldNames.yesNo.yes;
  let isApprovedFullyAndFunded = false;
  if(agencyValue && regionalValue && departmentValue && localValue && isFunded){
    isApprovedFullyAndFunded = true;
  }
  return isApprovedFullyAndFunded;
}
